import { IoCloseOutline } from 'react-icons/io5';

function OffCanvasCloseBtn({ handleClose, style = {} }) {
    return (
        <a className="offcanvas-close close-btn-modal text-25" onClick={handleClose} style={style}>
            <IoCloseOutline className='md' />
        </a>
    );
}

export default OffCanvasCloseBtn;